import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';

/** @param {any} props */
export default function FartherBreedersBanner({
  count,
  bodyText = 'These breeders are a little farther away from you, but they may offer safe, convenient puppy drop-off options.'
}) {
  return (
    <div className="PuppySearchResultsFartherBreedersBanner f2 f3-lg">
      <div className="flex items-center pv2">
        <div className="mr2">
          <Icon
            name="transportation-itinerary-colored"
            width="32px"
            height="32px"
          />
        </div>
        <p className="fw-medium">Explore {count} more breeders</p>
      </div>
      <p className="gray">{bodyText}</p>
    </div>
  );
}

FartherBreedersBanner.propTypes = {
  count: PropTypes.number.isRequired,
  bodyText: PropTypes.string
};
